<template>
  <div class="container">
        <span>验证码：{{verify}}</span>
        <el-input class="el-input" placeholder="请输入手机号" size="medium" v-model="phone" clearable></el-input>
        <el-select v-model="type" placeholder="请选择">
            <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.value"
            :value="item.value">
            </el-option>
        </el-select>
        <el-button class="el-button" @click="checkVerify">查询</el-button>
  </div>
</template>

<script>
export default {
    data(){
        return{
            verify:'',
            phone:'',
            type:'',
            options:[{value:'login'},{value:'register'},{value:'resetpwd'}]
        }
    },
    methods:{
        checkVerify(){
            var params = {
                phoneMd5:this.$md5(this.phone),
                type:this.type,
                telephone:this.phone
            }
            console.log(params)
            this.wjtHttp.post(this,'/api/getCode',params,true,(res)=>{
                var data = res.data
                if(data.code == 200){
                    this.verify = data.smsCode
                }else{
                    this.$message({
                        message:(data.msg&&data.msg.length > 0)?data.msg:'服务异常，请联系管理员',
                        type:'error'
                    })
                }
            })   
        }
    }
}
</script>

<style scoped>
.container{
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}
.container>span{
    width: 300px;
    margin-top: 50px;
    text-align: left;
}
.el-input{
    width: 300px;
    margin-top: 50px;
}
.el-button{
    margin-top: 50px;
}
</style>


// WEBPACK FOOTER //
// src/components/GetCode.vue